module.exports = __webpack_public_path__ + "assets/menu-empty-search-ce749e.svg";